a<template>
  <div class="container center-align">
    <img :src="error.icon" alt="Error" />
    <p v-if="nombre" class="nombre medium">
      Hola, <span data-obfuscate>{{ nombre }}</span>
    </p>
    <div class="mensaje-wrapper">
      <p>
        <span class="title">{{ error.title }}</span
        ><span v-safe-html="error.subtitle"></span>
      </p>
    </div>

    <div class="button-container" v-if="canGoBack">
      <sales-button
        @click.native="volver"
        class="sales-button"
        :label="error.buttonName || 'Volver'"
        analyticsName="volver"
        :analyticsModule="analyticsModule"
      />
    </div>
  </div>
</template>

<script>
import errores from "@/config/constants/errores";
import SalesButton from "@/components/core/SalesButton";
import {
  CLIENTE_NO_CENSADO,
  ERROR_CONFIRMACION_RENAPER
} from "@/config/constants/step-constants";

export default {
  name: "Mensaje",
  components: { SalesButton },
  methods: {
    volver() {
      if (this.error.buttonUrl) {
        window.location.href = this.error.buttonUrl;
        return;
      }
      if (this.$route.params.mje === ERROR_CONFIRMACION_RENAPER) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
    }
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    canGoBack() {
      return this.$route.params.mje !== CLIENTE_NO_CENSADO;
    },
    error() {
      return errores[this.$route.params.mje];
    },
    analyticsModule() {
      let name = this.error.analyticsModule;
      return name ? name : (this.$route.params.mje + "").replace("-", " ");
    }
  }
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
div.sales-button {
  width: 212px;
  height: 56px;
}

p.nombre {
  font-size: 28px;
  margin-bottom: 45px;
  margin-bottom: 32px;
}

div.mensaje-wrapper {
  color: #121212;
  font-size: 18px;
  margin: auto;
  max-width: 500px;
  margin-top: 16px;
  margin-bottom: 42px;
}

.mensaje-wrapper span {
  display: block;
  margin-bottom: 7px;
}

div.button-container {
  text-align: center;
}

.title {
  font-weight: bold;
}

@media screen and (max-width: 600px) {
  div.mensaje-wrapper {
    max-width: 290px;
  }
}
</style>
